import {
  USER_TYPES,
  generalAdabyronBehaviour,
} from '../../utils/adaByron';
import {
  MethodType,
  UnknownObject,
  Context,
} from '../../utils/types';
import {
  normalizeGetMyDataResponse,
  normalizeUpdateMyContactsRequest,
  normalizeUpdatePermanentResidenceRequest,
} from './normalizers';
import { MediumContact } from './types';
export enum PATHS {
  GET_MY_DATA = 'datoscliente/misdatos',
  GET_MY_DATA_TYPE = 'datoscliente/otrosdatos',
  UPDATE_MY_CONTACTS = 'datoscliente/misdatos/contacto',
  UPDATE_CONTACTS = 'venta/modificar/contacto',
  UPDATE_PERMANENT_RESIDENCE = 'datoscliente/residencia',
  UPDATE_RESIDENCE = 'venta/modificar/residencia',
  GET_DEBT_PAYMENT = 'datoscliente/misdatos/deuda',
  MODIFY_BANK_ACCOUNT = 'datoscliente/modificar/cuentabancaria',
  RECOVERY_PASSWORD = 'datoscliente/misdatos/contactopassword',
  RECOVERY_PASSWORD_MODIFY = 'datoscliente/misdatos/cambiocontacto',
  RECOVERY_PASSWORD_VALIDATE = 'datoscliente/misdatos/cambiocontacto/validar',
  UPDATE_UNIQUE_CONTACT = 'datoscliente/modificar/contactoUnico',
  UPGRADE_USER = 'gestioncredenciales/upgrade',
  GET_EMAIL_MPLUS = 'datoscliente/misdatos/email',
  GET_BANK_ACCOUNT = 'datoscliente/misdatos/cuentabancaria',
  CHANGE_PASSWORD = 'gestioncredenciales/update',
}

export const onGetMyDataSuccess = (
  xhr: XMLHttpRequest,
  onlyMobilePhone: boolean,
): UnknownObject => {
  const { response } = xhr;
  const { datos } = JSON.parse(response);
  return normalizeGetMyDataResponse(datos, onlyMobilePhone);
};

export const getMyData = (
  data: {
    onlyMobilePhone?: boolean;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { onlyMobilePhone = false } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_MY_DATA,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.OPEN],
    eventName: 'CLIENT.GET_MY_DATA',
    mockedInfo: 'getMyData',
    methodType: MethodType.GET,
    onSuccessCallback: (xhr: XMLHttpRequest) =>
      onGetMyDataSuccess(xhr, onlyMobilePhone),
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const getMyDataType = (
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_MY_DATA_TYPE,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.GET_MY_DATA_TYPE',
    mockedInfo: 'getMyDataType',
    methodType: MethodType.GET,
  });
};

export const onUpdateMyContactsSuccess = (): string => {
  return 'OK';
};

export const updateMyContacts = (
  data: {
    newContactEmail?: MediumContact;
    newContactPhone?: MediumContact;
    newContactTelf?: MediumContact;
    newContactFax?: MediumContact;
    newContactAddress?: MediumContact;
    additionalInfo: Array<MediumContact>;
    cqId?: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const {
    newContactEmail,
    newContactPhone,
    newContactTelf,
    newContactFax,
    newContactAddress,
    additionalInfo,
    cqId,
  } = data;

  const optionalQueryParams = [];
  if (cqId) {
    optionalQueryParams.push({ param: 'idCq', value: cqId });
  }

  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.UPDATE_MY_CONTACTS,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.UPDATE_MY_CONTACTS',
    queryParams: optionalQueryParams,
    mockedInfo: 'updateMyContacts',
    methodType: MethodType.POST,
    requestObject: normalizeUpdateMyContactsRequest({
      newContactEmail,
      newContactPhone,
      newContactTelf,
      newContactFax,
      newContactAddress,
      additionalInfo,
    }),
    onSuccessCallback: () => onUpdateMyContactsSuccess(),
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const updateContacts = (
  data: {
    newContactEmail?: MediumContact;
    newContactPhone?: MediumContact;
    newContactTelf?: MediumContact;
    newContactFax?: MediumContact;
    newContactAddress?: MediumContact;
    additionalInfo: Array<MediumContact>;
    cqId?: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const {
    newContactEmail,
    newContactPhone,
    newContactTelf,
    newContactFax,
    newContactAddress,
    additionalInfo,
    cqId,
  } = data;

  const optionalQueryParams = [];
  if (cqId) {
    optionalQueryParams.push({ param: 'idCq', value: cqId });
  }

  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.UPDATE_CONTACTS,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.UPDATE_CONTACTS',
    queryParams: optionalQueryParams,
    mockedInfo: 'updateContacts',
    methodType: MethodType.POST,
    requestObject: normalizeUpdateMyContactsRequest({
      newContactEmail,
      newContactPhone,
      newContactTelf,
      newContactFax,
      newContactAddress,
      additionalInfo,
    }),
    onSuccessCallback: () => onUpdateMyContactsSuccess(),
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 10,
  });
};

export const updatePermanentResidence = (
  data: {
    permanentResidenceId: number;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { permanentResidenceId } = data;

  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.UPDATE_PERMANENT_RESIDENCE,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.OPEN],
    eventName: 'CLIENT.UPDATE_PERMANENT_RESIDENCE',
    mockedInfo: 'updatePermanentResidence',
    methodType: MethodType.POST,
    requestObject: normalizeUpdatePermanentResidenceRequest({
      permanentResidenceId,
    }),
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const updateResidence = (
  data: {
    permanentResidenceId: number;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { permanentResidenceId } = data;

  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.UPDATE_RESIDENCE,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.OPEN],
    eventName: 'CLIENT.UPDATE_RESIDENCE',
    mockedInfo: 'updatePermanentResidence',
    methodType: MethodType.POST,
    requestObject: normalizeUpdatePermanentResidenceRequest({
      permanentResidenceId,
    }),
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 10,
  });
};

export const getDebtPayment = (
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_DEBT_PAYMENT,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.GET_DEBT_PAYMENT',
    mockedInfo: 'getDebtPayment',
    methodType: MethodType.GET,
  });
};

export const modifyBankAccount = (
  data: {
    bankEntityCode: string;
    bankOfficeCode: string;
    customerAccountId: string;
    customerAccountName: string;
    ibanCheckDigits: string;
    ibanCountryIso2Code: string;
    internationalIbanAccountNumber?: string;
    spanishIbanAccountNumber?: string;
    spanishIbanCheckDigits?: string;
  },
  context: Context,
  idFront = 'TC',
): Promise<unknown> => {
  const {
    bankEntityCode,
    bankOfficeCode,
    customerAccountId,
    customerAccountName,
    ibanCheckDigits,
    ibanCountryIso2Code,
    internationalIbanAccountNumber,
    spanishIbanAccountNumber,
    spanishIbanCheckDigits,
  } = data;

  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.MODIFY_BANK_ACCOUNT,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.MODIFY_BANK_ACCOUNT',
    mockedInfo: 'modifyBankAccount',
    methodType: MethodType.PUT,
    requestObject: {
      bankEntityCode,
      bankOfficeCode,
      customerAccountId,
      customerAccountName,
      ibanCheckDigits,
      ibanCountryIso2Code,
      internationalIbanAccountNumber,
      spanishIbanAccountNumber,
      spanishIbanCheckDigits,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const recoveryPassword = (
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.RECOVERY_PASSWORD,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.RECOVERY_PASSWORD',
    mockedInfo: 'recoveryPassword',
    methodType: MethodType.GET,
  });
};

export const recoveryPasswordModify = (
  data: { medioContacto: string },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { medioContacto } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.RECOVERY_PASSWORD_MODIFY,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.RECOVERY_PASSWORD_MODIFY',
    queryParams: [{ param: 'medioContacto', value: medioContacto }],
    mockedInfo: 'recoveryPasswordModify',
    methodType: MethodType.GET,
  });
};



export const recoveryPasswordValidate = (
  data: {
    securityMediumType: string;
    securityMedium: string;
    pin: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { securityMediumType, securityMedium, pin } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.RECOVERY_PASSWORD_VALIDATE,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.RECOBERY_PASSWORD_VALIDATE',
    mockedInfo: 'recoveryPasswordValidate',
    methodType: MethodType.POST,
    requestObject: {
      securityMediumType,
      securityMedium,
      pin,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};


export const updateUniqueContact = (
  data: {
    advertisingConsent: boolean;
    email: string;
    clientNif: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { advertisingConsent, email, clientNif } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.UPDATE_UNIQUE_CONTACT,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.UPDATE_UNIQUE_CONTACT',
    mockedInfo: 'updateUniqueContact',
    methodType: MethodType.PUT,
    requestObject: {
      consentimientoPublicidad: advertisingConsent,
      nifCliente: clientNif,
      email,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const upgradeUser = (
  data: {
    userName: string;
    password: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { userName, password } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.UPGRADE_USER,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.UPGRADE_USER',
    mockedInfo: 'upgradeUser',
    methodType: MethodType.POST,
    requestObject: {
      username: userName,
      password,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};

export const getEmailMovistarPlus = (
  data: { idProduct: string },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { idProduct } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_EMAIL_MPLUS,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.GET_EMAIL_MPLUS',
    queryParams: [
      {
        param: 'idProduct',
        value: idProduct,
      },
    ],
    mockedInfo: 'getEmailMovistarPlus',
    methodType: MethodType.GET,
  });
};

export const getBankAccount = (
  data: { customerAccountId: string },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { customerAccountId } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_BANK_ACCOUNT,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.GET_BANK_ACCOUNT',
    queryParams: [
      {
        param: 'customerAccountId',
        value: customerAccountId,
      },
    ],
    mockedInfo: 'getBankAccount',
    methodType: MethodType.GET,
  });
};
export const changePassword = (
  data: {
    newPassword: string;
  },
  context: Context,
  idFront = 'TC',
): Promise<unknown> => {
  const { newPassword } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.CHANGE_PASSWORD,
    userTypes: [USER_TYPES.CLIENT],
    eventName: 'CLIENT.CHANGE_PASSWORD',
    mockedInfo: 'changePassword',
    methodType: MethodType.POST,
    requestObject: {
      newPassword,
    },
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
  });
};
